import moment from 'moment';
import newhttp from '~/http/new';
import storeUtils from '~/utils/storeUtils';

export default ({
  state: {
    referrals: [],
    leads: [],
    page: 1,
    pages: 0,
    filters: {},
    sort: {
      sort: 'createdAt',
      sortDesc: true,
    },
  },

  getters: {
    requestData(state, _getters, _rootState, rootGetters) {
      const {
        page,
        filters,
        sort,
      } = state;

      const itemsPerPage = rootGetters['common/itemsPerPage'];

      const filteredFilters = storeUtils.clearEmptyParams(filters);

      const { cumulativeCurrencyId, ...rest } = filteredFilters;

      return {
        ...rest,
        ...sort,
        createdAtFromDate: filters.createdAtFromDate ? moment.utc(filters.createdAtFromDate).unix() : undefined,
        createdAtToDate: filters.createdAtToDate ? moment.utc(filters.createdAtToDate).set({ hour: 23, minute: 59, second: 59 }).unix() : undefined,
        offset: (page - 1) * itemsPerPage,
        limit: itemsPerPage,
      };
    },
  },

  mutations: {
    SET_FILTERS(state, data) { state.filters = data; },
    SET_PAGE(state, value) { state.page = value; },
    SET_PAGES(state, value) { state.pages = value; },
    SET_SORT(state, data) { state.sort = data; },

    SET_REFERRALS(state, data) {
      state.referrals = data;
    },
  },

  actions: {
    setPage({ commit }, value) { commit('SET_PAGE', value); },
    setPages({ commit }, value) { commit('SET_PAGES', value); },
    setFilters({ commit }, data) { commit('SET_FILTERS', data); },
    setSort({ commit }, data) { commit('SET_SORT', data); },

    async loadTraderLeadReferrals({ getters, commit, rootGetters }, data) {
      const itemsPerPage = rootGetters['common/itemsPerPage'];
      const response = await newhttp.get('v1/p2p/trader-lead-referrals', {
        params: {
          ...getters.requestData,
          ...data,
        },
      });
      const { referrals, totalCount } = response.data;
      commit('SET_REFERRALS', referrals);
      if (totalCount) {
        const pages = Math.ceil(totalCount / itemsPerPage);
        commit('SET_PAGES', pages);
      }
    },

    async addReferral(__store, data) {
      const response = await newhttp.post('v1/p2p/trader-lead-referrals', data);
      if (!response.data?.result?.Success) {
        throw new Error(response.data.result.Error);
      }
      return response.data;
    },

    async deleteReferral(__store, id) {
      const response = await newhttp.delete(`v1/p2p/trader-lead-referrals/${id}`, { id });

      if (!response.data?.result?.Success) {
        throw new Error(response.data.result.Error);
      }
      return response.data;
    },

    async editReferral(__store, data) {
      const response = await newhttp.put(`v1/p2p/trader-lead-referrals/${data.id}`, {
        payInPercentage: data.payInPercentage,
        payOutPercentage: data.payOutPercentage,
      });

      if (!response.data?.result?.Success) {
        throw new Error(response.data.result.Error);
      }
      return response.data;
    },
  },

  namespaced: true,
});
